<template>
  <div class="chart-line" ref="chartdiv"></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'

export default {
  name: 'chartLineRender',
  props: {
    chartKey: { type: String, required: true },
    fromDialog: { type: Boolean, required: false }
  },
  data () {
    return {
      chartSettings: {},
      chartData: []
    }
  },
  computed: {
    chartObj: {
      get () { return this.$store.getters.getChartByKey(this.chartKey) }
    }
  },
  mounted () {
    this.chartSettings = this.chartObj.chartSettings
    this.chartData = this.chartObj.data.result

    // check and reduce data if not in dialog
    if (!this.fromDialog && this.chartData.length > (this.chartObj.chartSettings.displayLength || 10)) {
      const reducedData = this.chartData.filter((data, index) => index < (this.chartObj.chartSettings.displayLength || 10))
      // this.$log.info('reducedData', reducedData)
      this.chartData = reducedData
    }

    let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart)
    chart.paddingRight = 20
    chart.maskBullets = false // if true, LabelBullets will be outside graph

    // Add data
    chart.data = this.chartData

    // Enable export if 'true' in chart setting
    /* if (this.chartObj.export) {
      chart.events.on('ready', () => {
        chart.exporting.menu = new am4core.ExportMenu()
        chart.exporting.menu.align = 'right'
        chart.exporting.menu.verticalAlign = 'bottom'
        chart.exporting.menu.items = [{
          'label': '...',
          'menu': [
            {
              'label': 'Image',
              'menu': [
                { 'type': 'png', 'label': 'PNG' },
                { 'type': 'jpg', 'label': 'JPG' },
                { 'type': 'gif', 'label': 'GIF' },
                { 'type': 'svg', 'label': 'SVG' },
                { 'type': 'pdf', 'label': 'PDF' }
              ]
            }, {
              'label': 'Data',
              'menu': [
                // { 'type': 'json', 'label': 'JSON' },
                { 'type': 'csv', 'label': 'CSV' }
                // { 'type': 'xlsx', 'label': 'XLSX' }
              ]
            }, {
              'label': 'Print', 'type': 'print'
            }
          ]
        }]
      })
    } */
    chart.data = this.chartData
    // Set input format for the dates
    chart.dateFormatter.inputDateFormat = this.chartObj.chartSettings.dateFormat || 'yyyy-MM-dd'

    // Create axes
    let dateAxis = chart.xAxes.push(new am4charts.DateAxis())
    // eslint-disable-next-line no-unused-vars
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis())
    valueAxis.min = 0

    // Create series
    let series = chart.series.push(new am4charts.LineSeries())
    series.dataFields.valueY = 'value'
    series.dataFields.dateX = 'name'
    series.tooltipText = '{value}'
    series.strokeWidth = 2
    series.minBulletDistance = 15

    // Drop-shaped tooltips
    series.tooltip.background.cornerRadius = 20
    series.tooltip.background.strokeOpacity = 0
    series.tooltip.pointerOrientation = 'vertical'
    series.tooltip.label.minWidth = 40
    series.tooltip.label.minHeight = 40
    series.tooltip.label.textAlign = 'middle'
    series.tooltip.label.textValign = 'middle'
    // series.connect = false

    // Make bullets grow on hover
    let bullet = series.bullets.push(new am4charts.CircleBullet())
    bullet.circle.strokeWidth = 2
    bullet.circle.radius = 4
    bullet.circle.fill = am4core.color('#fff')

    let bullethover = bullet.states.create('hover')
    bullethover.properties.scale = 1.3

    // Make a panning cursor
    chart.cursor = new am4charts.XYCursor()
    chart.cursor.behavior = 'panXY'
    chart.cursor.xAxis = dateAxis
    chart.cursor.snapToSeries = series

    // Create a horizontal scrollbar with previe and place it underneath the date axis
    chart.scrollbarX = new am4charts.XYChartScrollbar()
    chart.scrollbarX.series.push(series)
    chart.scrollbarX.parent = chart.bottomAxesContainer

    chart.events.on('ready', function () {
      dateAxis.zoom({ start: 0, end: 1 }) // { start: 0.79, end: 1 }
    })

    this.chart = chart
  },
  methods: {
    // addChart (value) {
    //   this.$store.commit('ADD_CHART', value)
    // },
    // clearCharts () {
    //   this.$store.commit('CLEAR_CHARTS')
    // }
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .chart-line {
    width: 100%;
    height: 400px;
  }
</style>
